import { defineStore } from 'pinia'

export const useFeatureFlagsStore = defineStore('featureFlagsStore', {
  state: () => ({
    // Placeholder for future API response data
    flags: {}
  }),
  actions: {
    isApplePayEnabled(restoId = null, customerId = null) {
      // Hardcoded allowed IDs as requested
      // If these arrays are empty or undefined, the feature is enabled for ALL
      const ENABLED_RESTO_IDS = [10500,10416]
      const ENABLED_CUSTOMER_IDS = [] 

      let isRestoAllowed = true
      // Check Resto only if provided
      if (restoId !== null && restoId !== undefined && restoId !== '') {
        const rId = Number(restoId)
        // If list is provided and not empty, check against it. Otherwise allow all.
        isRestoAllowed = (!ENABLED_RESTO_IDS || ENABLED_RESTO_IDS.length === 0) 
          ? true 
          : ENABLED_RESTO_IDS.includes(rId)
      }

      let isCustomerAllowed = true
      // Check Customer only if provided
      if (customerId !== null && customerId !== undefined && customerId !== '') {
        const cId = Number(customerId)
        // If list is provided and not empty, check against it. Otherwise allow all.
        isCustomerAllowed = (!ENABLED_CUSTOMER_IDS || ENABLED_CUSTOMER_IDS.length === 0)
          ? true
          : ENABLED_CUSTOMER_IDS.includes(cId)
      }

      const result = isRestoAllowed && isCustomerAllowed
      
      if (result) {
        console.log('Apple Pay/Stripe Payment Element ENABLED for this user/resto session.')
      }
      
      return result
    }
  }
})
